import { render, staticRenderFns } from "./speakerpage.vue?vue&type=template&id=7aab76ec"
import script from "./speakerpage.vue?vue&type=script&lang=js"
export * from "./speakerpage.vue?vue&type=script&lang=js"
import style0 from "./speakerpage.vue?vue&type=style&index=0&id=7aab76ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports